import { render, staticRenderFns } from "./ExpandedItem.vue?vue&type=template&id=469242d4&scoped=true&"
import script from "./ExpandedItem.vue?vue&type=script&lang=ts&"
export * from "./ExpandedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedItem.vue?vue&type=style&index=0&id=469242d4&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469242d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
